var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "balance-container" },
    [
      _vm.$store.getters.isAllCountry
        ? _c("MyAssets")
        : _c("BalanceWithdrawRecharge", { ref: "balanceActions" }),
      _c("BalanceTransDetails", {
        on: { "get-merchant-info": _vm.refreshBalance },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }